// mui
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px",
    width: 280,
    boxShadow: 3,
    fontSize: "1rem",
    position:'relative',
    top: '0px',
    '&:hover' : {
      top : '-2.5px',
      backgroundColor : '',
      boxShadow: '0px 4px 8px rgba(38, 38, 38, 0.2)',
    }
  },
  header: { 
    fontSize: "large",
  },
  dataKey: {
    fontSize: 14,
    fontWeight: 500,
    justifyContent: "start",
    alignItems : "center"
  },
  dataValue: {
    fontSize: 14,
    cursor: "default",
  },
}));

export default useStyles;



